import React from 'react';

/** True only when the build is explicitly marked as the test environment. */
export const isTestUi = (): boolean => process.env.REACT_APP_ENV === 'test';

const BAR_HEIGHT_PX = 44;

/**
 * Full-width fixed bar so the test environment cannot be mistaken for production.
 * Renders nothing unless REACT_APP_ENV=test.
 */
const TestingEnvBadge: React.FC = () => {
  if (!isTestUi()) return null;

  return (
    <>
      <div
        role="status"
        aria-label="Testing environment — not production"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 4000,
          height: BAR_HEIGHT_PX,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 12,
          background: '#b71c1c',
          color: '#ffffff',
          fontWeight: 800,
          fontSize: 15,
          letterSpacing: 1.6,
          textTransform: 'uppercase',
          boxShadow: '0 3px 10px rgba(0,0,0,0.35)',
          borderBottom: '3px solid #ffeb3b',
        }}
      >
        <span aria-hidden="true">●</span>
        Testing environment — not production
        <span aria-hidden="true">●</span>
      </div>
      <div style={{ height: BAR_HEIGHT_PX }} aria-hidden="true" />
    </>
  );
};

export default TestingEnvBadge;
